/** @jsxImportSource @emotion/react */
import { useSession } from '@quickbit/backoffice-core-frontend';
import { Input, Modal } from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useAsyncFn } from 'react-use';
import { addBackofficeUser } from '../api';

interface Props {
  merchantId: string;
  onClose: (added: boolean) => void;
}

export const AddBackofficeUserModal = ({ merchantId, onClose }: Props) => {
  const [email, setEmail] = useState('');
  const session = useSession();

  const [{ loading, error }, add] = useAsyncFn(async () => {
    if (!session.authenticated) return;
    await addBackofficeUser(merchantId, email, session.userId);
    onClose(true);
  }, [email]);

  return (
    <Modal
      title="Add Backoffice User"
      primaryButtonProps={
        error
          ? undefined
          : {
              text: 'Add user',
              onClick: add,
              disabled: loading || !email,
              loading: loading,
            }
      }
      secondaryButtonProps={{
        text: 'Cancel',
        onClick: () => onClose(false),
        disabled: loading,
      }}
    >
      {!error && (
        <Input
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          label="Email"
          disabled={loading}
        />
      )}
      {error && (
        <div>
          <p>Something went wrong...</p>
          <p>{error.errorMessage}</p>
        </div>
      )}
    </Modal>
  );
};
